import { isValidNamedPackage } from "./named-packages.mjs";
import { isValidStructTag } from "./safe-types.mjs";
//#region src/utils/move-registry.ts
/**
* Checks if a type contains valid named packages and is a valid Move struct tag.
*/
const isValidNamedType = (type) => {
	const splitType = type.split(/::|<|>|,/);
	for (const t of splitType) if (t.includes("/") && !isValidNamedPackage(t)) return false;
	return isValidStructTag(type);
};
//#endregion
export { isValidNamedPackage, isValidNamedType };

//# sourceMappingURL=move-registry.mjs.map